import { render, staticRenderFns } from "./WaiProjectSearch.vue?vue&type=template&id=06557c61&"
import script from "./WaiProjectSearch.vue?vue&type=script&lang=js&"
export * from "./WaiProjectSearch.vue?vue&type=script&lang=js&"
import style0 from "./WaiProjectSearch.vue?vue&type=style&index=0&id=06557c61&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports